import * as React from 'react'
import { safeBoolean } from '../../utils/utils'
import { Badge, badges } from 'DVWebNodeUI'

export interface HdrBadgeProps {
  isHdr?: boolean
}

export const Hdr = ({ isHdr }: HdrBadgeProps) => (
  safeBoolean(isHdr) &&
  (<Badge use={badges.BORDERED_TEXT}>
    <span data-automation-id="hdr-badge">HDR</span>
  </Badge>) || null
)
